/*
Site Information Mixins:
* Formatting methods
* Data retreval for standard queries.
--------------------------------------------------
*/

import DateMixins from '@/mixins/DateMixins'
import FormattingMixins from '@/mixins/FormattingMixins'
import PostMixins from '@/mixins/PostMixins'
import NumberMixins from '@/mixins/NumberMixins'

import {CANDIDATE_SITE, NEW_SITE, ACTIVE_SITE, EXCLUSIVE_SITE, LAND_ONLY_SITE, TEMP_SITE, DISMANTLED_SITE, SOLD_SITE} from '@/components/Data'
import { sanitiseHtml } from '@/lib/sanitiseHtml'


export default {

  mixins: [DateMixins, FormattingMixins, PostMixins, NumberMixins],

  methods: {

    isCandidate (status) {
      return status === this.candidateSite()
    },


    isExisting (status) {
      return status === this.activeSite()
    },


    isExclusive (status) {
      return status === this.exclusiveSite()
    },


    isDismatled (status) {
      return status === this.dismantledSite()
    },


    isLandOnly (status) {
      return status === this.landOnlySite()
    },


    isTemporary (status) {
      return status === this.temporarySite()
    },


    isSold (status) {
      return status === this.soldSite()
    },


    titleClass (status) {

      switch (status) {

        case this.candidateSite():
          return 'text-warning'

        case this.activeSite():
          return 'text-primary'

        case this.exclusiveSite():
          return 'text-black'

        case this.newSite():
          return 'text-success'

        case this.dismantledSite():
          return 'text-danger'

        case this.temporarySite():
          return 'text-regular'

        case this.landOnlySite():
          return 'text-muted'

        case this.soldSite():
          return 'text-danger'

        default:
          return null
      }
    },


    siteBgColor (status) {
      switch (status) {
        case this.candidateSite():
          return '#E6A23C52' // Need to tone it down

        case this.activeSite():
          return '#e3f2fd'

        case this.exclusiveSite():
          return '#30313352' // Need to tone it down

        case this.newSite():
          return '#e0f2f1'

        case this.landOnlySite():
          return '#F2F6FC'

        case this.dismantledSite():
          return '#fbe9e7'

        case this.temporarySite():
          return '#EBEEF5'

        default:
          return '#efebe9'
      }
    },


    newSite () {
      return NEW_SITE
    },


    temporarySite () {
      return TEMP_SITE
    },


    activeSite () {
      return ACTIVE_SITE
    },


    exclusiveSite () {
      return EXCLUSIVE_SITE
    },


    landOnlySite () {
      return LAND_ONLY_SITE
    },


    candidateSite () {
      return CANDIDATE_SITE
    },


    dismantledSite () {
      return DISMANTLED_SITE
    },


    soldSite () {
      return SOLD_SITE
    },


    siteStatus (value, shorten = false) {

      if (!value) {
        return null
      }

      var v = value
      var icon = ''
      var color = 'darkgrey'

      if (value === TEMP_SITE) {
        icon = 'clock'
      }

      if (value === LAND_ONLY_SITE) {
        icon = 'map'
      }

      if (value === DISMANTLED_SITE) {
        color = 'indianred'
        icon = 'bolt'
      }

      if (value === SOLD_SITE) {
        color = 'firebrick'
        icon = 'money-bill-wave'
      }

      if (value === CANDIDATE_SITE) {
        color = 'goldenrod'
        icon = 'map-pin'
      }

      if (value === EXCLUSIVE_SITE) {
        color = 'black'
        icon = 'asterisk'
      }

      if (value === ACTIVE_SITE) {
        color = 'CornflowerBlue'
        icon = 'dot-circle'
      }

      if (value === NEW_SITE) {
        color = 'LimeGreen'
        icon = 'plus-square'
      }

      v = value.replace(' Site', '')

      if (shorten || (this.isXSmall || this.isSmall)) {
        v = ''
      }

      return sanitiseHtml('<div class="tooltip"><i class="fa fa-' + icon + '" style="color: ' + color + ';">' +
        '</i>&nbsp;<span style="color: ' + color + ';">&nbsp;' +
        v + '</span>' + (shorten ? '<span class="tooltiptext">' + value + '</span>' : '') + '</div>')
    },


    formatSiteStatus (value) {
      return this.siteStatus(value, true)
    },


    formatActions (value) {
      var icon = ''
      var color = 'darkgrey'
      var bg = 'transparent'

      var num = Number(value)

      if (num === 0) {
        icon = ''
        color = 'transparent'
      }

      if (num >= 1 && num <= 2) {
        color = '#182d54'
        bg = 'inherit'
      }

      if (num >= 3 && num <= 5) {
        color = '#24427a'
        icon = 'exclamation'
        bg = 'inherit'
      }

      if (num >= 6) {
        color = '#3766bd'
        icon = 'bolt'
        bg = 'inherit'
      }

      return '<span style="background-color: ' + bg + '">&nbsp;<span style="color: ' + color + ';">&nbsp;' +
        (this.isMediumOrLess ? '' : value) +
        '</span>' + (icon ? '&nbsp;<i class="fa fa-' + icon + '" style="color: ' + color + ';">' : '') +
          '</i></span>'
/*
      return '<b style="padding: 0.3em; background-color: ' + bg + '; border-radius:5px;">' + (icon ? '<i class="fa fa-' + icon + '" style="color: ' + color + ';">' : '') +
        '</i>&nbsp;<span style="color: ' + color + ';">&nbsp;' +
        (this.isMediumOrLess ? '' : value) +
        '</span></b>'
*/
    },

    formatTickets (value) {
      var icon = ''
      var color = 'dimgray'
      var bg = 'transparent'

      var num = Number(value)

      if (num === 0) {
        icon = ''
        color = 'transparent'
      }

      if (num === 1) {
        color = '#cd5c5c'
        icon = ''
      }

      if (num === 2) {
        color = '#b85252'
        icon = 'chevron-right'
      }

      if (num === 3) {
        color = '#a44949'
        icon = 'chevron-up'
      }

      if (num === 4) {
        color = '#8f4040'
        icon = 'angle-double-up'
      }

      if (num === 5) {
        color = '#7b3737'
        icon = 'exclamation'
      }

      if (num >= 6) {
        color = '#662e2e'
        icon = 'exclamation-triangle'
      }

      return '<span style="background-color: ' + bg + ';"><i class="fa fa-' + icon + '" style="color: ' + color + ';">' +
        '</i>&nbsp;<span style="color: ' + color + ';">&nbsp;' +
        (this.isMediumOrLess ? '' : value) +
        '</span></span>'
    },


    formatCategory (value) {

      if (!value) {
        return null
      }

      var formatted = value

      if (value.includes(': ')) {
        formatted = '<i>' + formatted.replace(': ', ':</i> <b>') + '</b>'
      } else {
        formatted = '<b>' + value + '</b>'
      }

      return formatted
    },

    formatPriority (value) {
      var icon = ''
      var end = ''

      if (value === 'Critical') {
        icon = '<i class="fa fa-asterisk" style="color: indianred;"></i>&nbsp;'
      }

      if (value === 'Urgent') {
        icon = '<i class="fa fa-chevron-up"  style="color: indianred;"></i>&nbsp;'
      }

      if (value === 'Medium') {
        icon = '<i class="fa fa-minus"  style="color: seagreen;"></i>&nbsp;'
      }

      if (value === 'Low') {
        icon = '<i class="fa fa-chevron-down"  style="color: slategray;"></i>&nbsp;'
      }

      if (value === 'Unkown') {
        icon = '<i class="fa fa-random"  style="color: goldenrod;"></i>&nbsp;'
      }

      return sanitiseHtml(icon +
       (this.isMobile ? '' : value) +
       end)
    },

    formatStatus (value, inclText = true) {
      var icon = ''
      var color = 'darkgrey'

      if (value === 'Closed') {
        color = 'seagreen'
        icon = 'check-square'
      }

      if (value === 'On Hold') {
        icon = 'clock'
      }

      if (value === 'Approved') {
        color = 'seagreen'
        icon = 'thumbs-up'
      }

      if (value === 'Overdue') {
        color = 'indianred'
        icon = 'hourglass-end'
      }

      if (value === 'In Progress') {
        color = 'slateblue'
        icon = 'cog'
      }

      if (value === 'Open') {
        icon = 'folder-open'
      }

      if (value === 'Needs Review') {
        color = 'indianred'
        icon = 'eye'
      }

      if (value === 'Pending') {
        color = 'goldenrod'
        icon = 'random'
      }

      return sanitiseHtml('<b><i class="fa fa-' + icon + '" style="color: ' + color + ';">' +
        '</i>&nbsp;<span style="color: ' + color + ';">&nbsp;' +
        (this.isMobile ? '' : (inclText ? (value ? value : '') : '')) +
        '</span></b>')
    },


    saveSite (site, message = 'Site Saved', callback = this.localSiteSuccess) {

      if (site && site.id) {
        site.handover = this.formatDateSql(site.handover)
        site.active = this.formatDateSql(site.active)
        site.dismantled = this.formatDateSql(site.dismantled)

        site.latitude = Number(site.latitude)
        site.longitude = Number(site.longitude)

        if (site.id) {
          this.saveForm(this, '/sites', site.id, site, site.siteName, callback)
        } else {
          this.$message({message: 'No site ID provided- can\'t save site', type: 'error'})
        }

      } else {
        this.$message({message: 'No site data to save', type: 'error'})
      }

    },

    localSiteSuccess (response) {
      this.refreshStats()
    },

    findSite (id, callback) {

      if (typeof id === 'number') {
        this.fetchData('/site/' + id, callback, 'site')
      } else {
        if (id) {
          console.error('SiteMixins::findSite - invalid id:', id)
        }
      }

    }, // findSite

    findSiteView (id, callback) {

      if (typeof id === 'number') {
        this.fetchData('/view/site/' + id, callback, 'site')
      } else {
        if (id) {
          console.error('SiteMixins::findSiteView - invalid id:', id)
        }
      }

    }, // findSite


    filterSites (filter, callback, sharerId = null, not = false, actions = null) {

      var url = '/sites' +
      (sharerId ? ('/sharer/' + (not ? 'not/' : '') + sharerId) : '') + (actions ? '/' + actions : '') +
       '/?sort=siteName%7Casc&page=1&per_page=30&filter=' + filter

      this.fetchData(url, callback, 'sites')
    }, // filterSites


    filterBackhaulSites (filter, callback, sharerId, providerId = null) {

      if (this.isTelco()) {
        sharerId = this.org().id
      }

      var url = '/sites/backhaul/sharer' +
      (sharerId ? ('/' + sharerId) : '/null') +
      (providerId ? '/' + providerId : '') +
       '/?sort=siteName%7Casc&page=1&per_page=30&filter=' + filter

      this.fetchData(url, callback, 'sites')
    }, // filterBackhaulSites


    findOrganisation (id, callback, withContacts = false) {

      var url = '/org/' + id + (withContacts ? '/contacts' : '')

      this.fetchData(url, callback, 'organisations')
    }, // findOrganisation


    filterOrganisation (
      filter,
      callback,
      type,
      isSelect = false
    ) {
      var text = (type ? type : 'organisation')

      var url = '/org' +
      (type ? '/category/' + type +
      (isSelect ? '/select' : '') : '') +
      '?sort=' + (isSelect ? 'label' : '' ) + '%7Casc' + (filter ? '&filter=' + filter : '')

      this.fetchData(url, callback, this.plural(text))
    }, // filterOrganisation


    filterAuthority (filter, callback, isSelect = false) {
      this.filterOrganisation(
        filter,
        callback,
        'authority',
        isSelect
      )
    }, // filterAuthority



    filterBackhaul (filter, callback, isSelect = false) {
      this.filterOrganisation(
        filter,
        callback,
        'backhaul',
        isSelect
      )
    }, // filterBackhaul



    filterContractors (filter, callback, isSelect = false) {
      this.filterOrganisation(
        filter,
        callback,
        'contractor',
        isSelect
      )
    }, // filterContractors



    filterLandlords (filter, callback, isSelect = false) {
      this.filterOrganisation(
        filter,
        callback,
        'landlord',
        isSelect
      )
    }, // filterLandlords


    filterInsurers (filter, callback, isSelect = false) {
      this.filterOrganisation(
        filter,
        callback,
        'insurer',
        isSelect
      )
    }, // filterInsurers


    filterLicensee (filter, callback, isSelect = false) {
      this.filterOrganisation(
        filter,
        callback,
        'licensee',
        isSelect
      )
    }, // filterLicensee


    filterSuppliers (filter, callback, isSelect = false) {
      this.filterOrganisation(
        filter,
        callback,
        'tower',
        isSelect
      )
    }, // filterSuppliers



    filterUtility (filter, callback, isSelect = false) {
      this.filterOrganisation(
        filter,
        callback,
        'utility',
        isSelect
      )
    }, // filterUtility



    findSiteBackhaulProviders (siteId, callback, errorCallback = null) {
      this.fetchData('backhaul/site/' + siteId, callback, 'Backhaul provider', errorCallback)
    },


    findSiteTenancy (siteId, callback, errorCallback = null) {
      this.fetchData('tenancy/site/' + siteId, callback, 'Tenancies', errorCallback)
    },


    findSiteSharers (siteId, callback, errorCallback = null) {
      this.fetchData('licensees/site/' + siteId, callback, 'Sharers', errorCallback)
    },


    findSiteStructures (siteId, callback, errorCallback = null) {
      this.fetchData('site-struct/site/' + siteId, callback, 'Tenancies', errorCallback)
    },


    findSiteUtilities (siteId, callback, errorCallback = null) {
      this.fetchData('utilities/site/' + siteId, callback, 'utilities', errorCallback)
    }, // findUtilities


    findFinanceSummary (callback, errorCallback = null) {
      this.fetchData('reports/finance/raw/summary', callback, 'sumary', errorCallback)
    },


    findFinanceSummaryByYear (year, callback, errorCallback = null) {
      this.fetchData('reports/finance/raw/summary/' + year, callback, 'sumary', errorCallback)
    },


    findSiteFinanceSummary (siteId, callback, errorCallback = null) {
      this.fetchData('reports/finance/raw/site/summary/' + siteId, callback, 'sumary', errorCallback)
    },


    findSiteFinanceSummaryForYear (year, siteId, callback, errorCallback = null) {
      this.fetchData('reports/finance/site/summary/' + year + '/null/' + siteId, callback, 'sumary', errorCallback)
    },


    findFinanceStatement (callback, errorCallback = null) {
      this.fetchData('reports/finance/statement', callback, 'sumary', errorCallback)
    },


    findFinanceStatementByYear (year, callback, errorCallback = null) {
      this.fetchData('reports/finance/statement/' + year, callback, 'sumary', errorCallback)
    },


    findSiteFinanceStatement (siteId, callback, errorCallback = null) {
      this.fetchData('reports/finance/statement/site/' + siteId, callback, 'sumary', errorCallback)
    },


    findSiteFinanceStatementForYear (year, siteId, callback, errorCallback = null) {
      this.fetchData('reports/finance/statement/' + year + '/site/' + siteId, callback, 'sumary')
    },


    findSitesReport (callback, errorCallback = null) {
      this.fetchData('report/sites', callback, 'sumary', errorCallback)
    },


    findSitesReportByYear (year, callback, errorCallback = null) {
      if (year && typeof year === 'number') {
        this.fetchData('report/sites/' + year, callback, 'summary', errorCallback)
      } else {
        this.$notify({
          type: 'error',
          message: 'Report Sites byYear: Year must be a number '
        })
      }
    }
  }
}
